window.datepickerStorage = {};

$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
	icons: {
		time: 'far fa-clock',
		date: 'far fa-calendar',
		up: 'far fa-arrow-up',
		down: 'far fa-arrow-down',
		previous: 'far fa-chevron-left',
		next: 'far fa-chevron-right',
		today: 'far fa-calendar-check',
		clear: 'far fa-trash',
		close: 'far fa-times'
	}
});

$(() => loadDatepickers());

window.loadDatepickers = function () {
	$('.date[datepicker-uuid][initialized="false"]').each((index, datepicker) => {
		const uuid = $(datepicker).attr('datepicker-uuid');

		window.datepickerStorage[uuid] = {
			picker:		$(datepicker),
			year:		null,
			month:		null,
			day:		null,
			formatted:	() => {
				const components = [
					window.datepickerStorage[uuid].day,
					window.datepickerStorage[uuid].month,
					window.datepickerStorage[uuid].year,
				];

				return components
					.filter(component => component !== null)
					.map(component => String(component).padStart(2, '0'))
					.join('.');
			}
		};

		$(datepicker).datetimepicker({
			locale: 'de',
			format: 'DD.MM.YYYY',
			keepInvalid: true,
			autocompleteYear19: true,
			calendarWeeks: true,
			buttons: {
				showToday: true,
				showClear: true,
				showClose: true
			},
			useCurrent: false,
			allowInputToggle: true,
			tooltips: {
				today: 'Heute',
				clear: 'Auswahl entfernen',
				close: 'Auswahl schließen',
				selectMonth: 'Monat wählen',
				nextMonth: 'Nächster Monat',
				selectYear: 'Jahr wählen',
				prevYear: 'Vorheriges Jahr',
				nextYear: 'Nächstes Jahr',
				selectDecade: 'Dekade wählen',
				prevDecade: 'Vorherige Dekade',
				nextDecade: 'Nächste Dekade',
				prevCentury: 'Vorheriges Jahrhundert',
				nextCentury: 'Nächstes Jahrhundert',
			}
		});

		$(datepicker).on('update.datetimepicker', event => {
			const date = event.date || false;

			//
			// The date was cleared
			if (date === false || event.action == 'clear') {
				window.datepickerStorage[uuid].day		= null;
				window.datepickerStorage[uuid].month	= null;
				window.datepickerStorage[uuid].year		= null;
			} else {
				window.datepickerStorage[uuid].day		= date.date();
				window.datepickerStorage[uuid].month	= date.month() + 1;
				window.datepickerStorage[uuid].year		= date.year();

				if (event.action == 'selectYear') {
					window.datepickerStorage[uuid].day		= null;
					window.datepickerStorage[uuid].month	= null;
				} else if (event.action == 'selectMonth') {
					window.datepickerStorage[uuid].day		= null;
				}
			}

			const formatted = window.datepickerStorage[uuid].formatted();
			$(datepicker).find('input.datetimepicker-input').val(formatted);
		});

		$(datepicker).attr('initialized', 'true')
	});
}
